<template>
    <div class="cancel-subscription-process-modal">
        <ProcessModal
            data-qa="cancel-subscription-process-modal-process"
            :is-open="isOpen"
            :title="$t('funnel.edit.lightbox.title.cancelSubscription')"
            :summary-text="$t('funnel.edit.cancel.subscription.actionSummary.text')"
            @close-modal="closeModal"
            @update-config="updateConfig"
        >
            <template #processParameters>
                <DsMultiselect
                    v-model="selectedSubscriptions"
                    :placeholder="$t('funnel.edit.cancel.subscription.message')"
                    :options="options"
                    bind-value-only
                    custom-chip-label
                    multiple
                    searchable
                    :readonly="isLoading"
                    :loading="isLoading"
                    class="select-subscriptions-to-cancel"
                    :force-invalid="hasError"
                >
                    <template #selection="{ option, remove }">
                        <DsChip
                            remove
                            with-interaction
                            @mousedown.native.stop.prevent="remove"
                        >
                            <template #default>
                                {{ option.chipLabel || option.label }}
                            </template>
                        </DsChip>
                    </template>
                    <template #help>
                        <span v-if="hasError">
                            {{ $t('funnel.edit.cancel.subscription.error.required') }}
                        </span>
                    </template>
                </DsMultiselect>
            </template>
        </ProcessModal>
    </div>
</template>

<script>
import ProcessModal from '../processModal/ProcessModal.vue';
import { subscriptionsByProduct } from './cancel.subscription.api';

export default {
    components: {
        ProcessModal,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                    subscriptionPlanIds: [],
                },
            }),
        },
    },
    emits: ['close-modal', 'update-cell-value'],
    data() {
        return {
            selectedSubscriptions: [],
            options: [],
            isLoading: false,
            hasError: false,
        };
    },
    mounted() {
        this.loadSubscriptions();
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        async updateConfig() {
            this.hasError = this.selectedSubscriptions.length <= 0;

            if (!this.hasError) {
                const cell = { ...this.cell };

                cell.value = cell.value || {};

                cell.value.subscriptionPlanIds = this.selectedSubscriptions;

                this.$emit('update-cell-value', { cell });
            }
        },
        async loadSubscriptions() {
            try {
                this.isLoading = true;
                const subscriptions = await subscriptionsByProduct();

                const result = Object.entries(subscriptions).map(([key, value]) => {
                    const label = key.slice(key.indexOf(',') + 1, -1);
                    const options = Object.entries(value).map(([optionValue, optionLabel]) => ({
                        value: optionValue,
                        label: optionLabel,
                        chipLabel: `${label} > ${optionLabel}`,
                    }));

                    return { label, options };
                });

                this.options = result;
                const subscriptionPlans = this.cell?.value?.subscriptionPlanIds ?? [];

                this.selectedSubscriptions = subscriptionPlans.map((subs) => subs.toString().replace('L', ''));
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Could not cancel subscriptions: ${error}`);
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
